import { Button, PageHeader, Surface, navigate } from "../shared/ui";

export function PasswordChangedNotice() {
  return <div className="auth-page member-identity-card member-password-complete">
    <PageHeader title="비밀번호가 변경되었습니다" description="보안을 위해 기존 로그인은 모두 종료했습니다. 새 비밀번호로 다시 로그인해 주세요." />
    <Surface><Button size="large" onClick={() => navigate("/login", true)}>로그인하기</Button></Surface>
  </div>;
}
